export enum OtpChannelType {
  SMS = 'sms',
  EMAIL = 'email',
}
